module.exports = __webpack_public_path__ + "img/pig.22302e9.png";